'use strict';

// ----------------------------------------
// Public
// ----------------------------------------

function subMenuToggle (item, wrap, slide) {
	let $wrap;
	let $openWrap = $(wrap + '.open');
	let $this;

	if ($openWrap) {
		$openWrap.find(slide).slideDown('fast');
	}

	$(item).click(function (e) {
		e.preventDefault();

		$this = $(this);
		$wrap = $this.closest($(wrap));

		$wrap.find(slide).slideToggle('fast');
		$wrap.toggleClass('open');
		$this.toggleClass('open');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {subMenuToggle};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/sub-menu.js